import I18n from 'i18n-js';
import React from 'react';
import { isEmpty } from 'lodash';
import CSPSquareCard from './csp_square_card';
import CSP from './comparison_shopping_page';

import Tiles from '@reverbdotcom/commons/src/components/tiles';

const COMPONENT_NAME = 'CSPMiniGrid';

interface Props {
  skipTracking?: boolean;
  pages: CSP[];
  calloutLink?: string;
  heading?: string;
  stripBrandFromTitle?: boolean;
}

export default class CSPMiniGrid extends React.Component<Props, {}> {
  shouldRender(pages) {
    return !(isEmpty(pages));
  }

  renderCallout() {
    if (!this.props.calloutLink) { return null; }

    return (
      <div className="csp-thumbs__action">
        <a href={this.props.calloutLink}>
          {I18n.t('discovery.cspMiniGrid.explore')}
        </a>
      </div>
    );
  }

  render() {
    return (
      <section className="csp-thumbs">
        <h2 className="csp-thumbs__heading">
          {this.props.heading}
        </h2>
        <div className="csp-thumbs__items">
          <Tiles
            placeholder={<CSPSquareCard />}
            loading={!this.shouldRender(this.props.pages)}
          >
            {this.props.pages.map((page, idx) => (
              <CSPSquareCard
                trackName={COMPONENT_NAME}
                key={idx}
                page={page}
                position={idx + 1}
                stripBrandFromTitle={this.props.stripBrandFromTitle}
                skipTracking={this.props.skipTracking}
              />
            ))}
          </Tiles>
        </div>
        {this.renderCallout()}
      </section>
    );
  }
}
